(() => {
  const root = document.querySelector('[data-msp-stove]');
  if (!root) return;

  const grid = root.querySelector('[data-stove-grid]');
  const cards = [...grid.querySelectorAll('[data-stove-product]')];
  const groups = [...root.querySelectorAll('[data-filter-group]')];
  const count = root.querySelector('[data-result-count]');
  const empty = root.querySelector('[data-stove-empty]');
  const reset = root.querySelector('[data-stove-reset]');
  const sort = root.querySelector('[data-stove-sort]');
  const more = root.querySelector('[data-stove-more]');
  const resultsHead = root.querySelector('.msp-stove-results-head');
  const activeFilters = root.querySelector('[data-active-filters]');
  const defaultSort = 'recommended';
  let resultLimit = 12;
  let finderOpen = false;

  const emit = (name, detail = {}) => document.dispatchEvent(new CustomEvent(`msp:stove-${name}`, { detail }));
  const numberFrom = (value) => {
    const match = String(value || '').replace(',', '.').match(/\d+(?:\.\d+)?/);
    return match ? Number(match[0]) : null;
  };
  const powerOf = (card) => numberFrom(card.dataset.power) ?? numberFrom(card.dataset.search.match(/\d+(?:[.,]\d+)?\s*kw/i)?.[0]);

  cards.forEach((card) => { card.dataset.powerNumber = powerOf(card) ?? ''; });

  const matches = (card, button) => {
    const value = button.dataset.filterValue;
    const group = button.closest('[data-filter-group]')?.dataset.filterGroup || (['stove', 'storage', 'hybrid', 'water'].includes(value) ? 'kind' : 'storage');
    if (group === 'kind') {
      if (value === 'stove') return card.dataset.kind !== 'hybrid';
      if (value === 'storage') return card.dataset.storage !== 'none' && card.dataset.kind !== 'hybrid';
      if (value === 'water') return card.dataset.water === 'true';
      return card.dataset.kind === value;
    }
    if (group === 'room') return card.dataset.room === value;
    if (group === 'outlet') return card.dataset.outlet === value;
    if (group === 'diameter') return numberFrom(card.dataset.diameter) === Number(value);
    if (group === 'air') return value === 'external' ? card.dataset.externalAir === 'true' : value === 'dibt' ? card.dataset.dibt === 'true' : false;
    if (group === 'fuel') {
      const fuel = card.dataset.fuel.toLowerCase();
      if (value === 'hybrid') return fuel.includes('hybrid') || fuel.includes('pellet');
      if (value === 'coal') return fuel.includes('kohle');
      return value === 'wood' && fuel.includes('holz');
    }
    if (group === 'cladding') return card.dataset.cladding.split(' ').includes(value);
    if (group === 'budget') {
      const price = Number(card.dataset.price);
      if (value === 'to-2000') return price <= 200000;
      if (value === '2000-4000') return price > 200000 && price <= 400000;
      if (value === '4000-6000') return price > 400000 && price <= 600000;
      return value === 'over-6000' && price > 600000;
    }
    if (group === 'storage') {
      if (value === 'with') return card.dataset.storage !== 'none' && card.dataset.kind !== 'hybrid';
      if (value === 'stone' || value === 'ceramic') return card.dataset.design.split(' ').includes(value);
      return false;
    }
    if (group === 'design') return card.dataset.design.split(' ').includes(value);
    if (group === 'vendor') return card.dataset.vendor === value;
    if (group === 'power') {
      const power = Number(card.dataset.powerNumber);
      if (!power) return false;
      const [min, max] = value.split(':').map(Number);
      return power >= min && (!max || power < max);
    }
    return true;
  };

  const activeFor = (group) => [...group.querySelectorAll('[data-filter-value][aria-pressed="true"]')];
  const closeGroup = (group, restoreFocus = false) => {
    const toggle = group?.querySelector('[data-group-toggle]');
    const panel = toggle?.nextElementSibling;
    if (!toggle || !panel) return;
    const wasOpen = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', 'false');
    panel.hidden = true;
    if (restoreFocus && wasOpen) toggle.focus({ preventScroll: true });
  };
  const closeGroups = (except = null) => groups.forEach((group) => {
    if (group !== except) closeGroup(group);
  });
  const apply = () => {
    const activeGroups = groups.map((group) => ({ group, active: activeFor(group) })).filter((item) => item.active.length);
    const matched = cards.filter((card) => activeGroups.every(({ active }) => active.some((button) => matches(card, button))));
    const shouldShow = finderOpen || activeGroups.length > 0;
    let visible = 0;
    cards.forEach((card) => {
      const match = matched.includes(card);
      const show = shouldShow && match && visible < resultLimit;
      card.hidden = !show;
      if (show) visible += 1;
    });
    grid.hidden = !shouldShow;
    resultsHead.classList.toggle('is-idle', !shouldShow);
    count.textContent = shouldShow ? `${matched.length} passende${matched.length === 1 ? 'r' : ''} ${matched.length === 1 ? 'Kaminofen' : 'Kaminöfen'}${matched.length > visible ? ` – ${visible} angezeigt` : ''}` : 'Wählen Sie mindestens einen Filter';
    empty.hidden = !shouldShow || matched.length !== 0;
    more.hidden = !shouldShow || visible >= matched.length;
    activeFilters.replaceChildren(...activeGroups.flatMap(({ active }) => active.map((button) => {
      const chip = document.createElement('button');
      chip.type = 'button';
      chip.textContent = `${button.textContent.trim()} ×`;
      chip.addEventListener('click', () => { button.setAttribute('aria-pressed', 'false'); resultLimit = 12; apply(); });
      return chip;
    })));
    reset.disabled = activeGroups.length === 0;
    emit('filter', { filters: activeGroups.map(({ group, active }) => ({ group: group.dataset.filterGroup, values: active.map((button) => button.dataset.filterValue) })), results: visible });
  };

  const sortCards = () => {
    const mode = sort.value;
    const sorted = [...cards].sort((a, b) => {
      if (mode === 'price-asc') return Number(a.dataset.price) - Number(b.dataset.price);
      if (mode === 'price-desc') return Number(b.dataset.price) - Number(a.dataset.price);
      if (mode === 'power-asc') return (Number(a.dataset.powerNumber) || 999) - (Number(b.dataset.powerNumber) || 999);
      if (mode === 'power-desc') return (Number(b.dataset.powerNumber) || -1) - (Number(a.dataset.powerNumber) || -1);
      if (mode === 'storage') return Number(b.dataset.storage !== 'none') - Number(a.dataset.storage !== 'none') || Number(a.dataset.index) - Number(b.dataset.index);
      return Number(a.dataset.index) - Number(b.dataset.index);
    });
    sorted.forEach((card) => grid.append(card));
    emit('sort', { mode });
  };

  root.addEventListener('click', (event) => {
    const filter = event.target.closest('[data-filter-value]');
    if (filter) {
      const ownGroup = filter.closest('[data-filter-group]');
      if (ownGroup) {
        filter.setAttribute('aria-pressed', filter.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
      } else {
        const value = filter.dataset.filterValue;
        const groupName = ['stove', 'storage', 'hybrid', 'water'].includes(value) ? 'kind' : 'storage';
        const group = root.querySelector(`[data-filter-group="${groupName}"]`);
        group.querySelectorAll('[data-filter-value]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.filterValue === value)));
      }
      apply();
      if (ownGroup) closeGroup(ownGroup, true);
      if (filter.hasAttribute('data-scroll-results')) root.querySelector('#msp-stove-results').scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    const groupToggle = event.target.closest('[data-group-toggle]');
    if (groupToggle) {
      const panel = groupToggle.nextElementSibling;
      const open = groupToggle.getAttribute('aria-expanded') !== 'true';
      if (open) closeGroups(groupToggle.closest('[data-filter-group]'));
      groupToggle.setAttribute('aria-expanded', String(open));
      panel.hidden = !open;
      return;
    }
    const tracked = event.target.closest('[data-stove-track]');
    if (tracked) emit(tracked.dataset.stoveTrack, { href: tracked.getAttribute('href') || '' });
  });

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element) || !event.target.closest('[data-filter-group]')) closeGroups();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const openGroup = groups.find((group) => group.querySelector('[data-group-toggle]')?.getAttribute('aria-expanded') === 'true');
    if (!openGroup) return;
    event.preventDefault();
    closeGroup(openGroup, true);
  });

  reset.addEventListener('click', () => {
    root.querySelectorAll('[data-filter-value][aria-pressed="true"]').forEach((button) => button.setAttribute('aria-pressed', 'false'));
    finderOpen = false;
    resultLimit = 12;
    apply();
  });
  sort.addEventListener('change', sortCards);

  root.querySelectorAll('[data-filter-value]').forEach((button) => {
    if (!cards.some((card) => matches(card, button))) button.hidden = true;
  });
  groups.forEach((group) => {
    if (![...group.querySelectorAll('[data-filter-value]')].some((button) => !button.hidden)) group.hidden = true;
  });
  more.addEventListener('click', () => {
    resultLimit += 12;
    apply();
  });
  root.querySelectorAll('[data-open-finder]').forEach((button) => button.addEventListener('click', () => {
    finderOpen = true;
    resultLimit = 12;
    apply();
    resultsHead.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }));
  root.querySelectorAll('[data-slider-next]').forEach((button) => button.addEventListener('click', () => {
    const slider = root.querySelector(`[data-slider="${button.dataset.sliderNext}"]`);
    slider?.scrollBy({ left: slider.clientWidth * .82, behavior: 'smooth' });
  }));
  const showcase = root.querySelector('[data-stove-showcase]');
  if (showcase) {
    const tabs = [...showcase.querySelectorAll('[data-stove-product-tab]')];
    const panels = [...showcase.querySelectorAll('[data-stove-product-panel]')];
    const activateTab = (name, moveFocus = false) => {
      tabs.forEach((tab) => {
        const active = tab.dataset.stoveProductTab === name;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        if (active && moveFocus) tab.focus({ preventScroll: true });
      });
      panels.forEach((panel) => {
        const active = panel.dataset.stoveProductPanel === name;
        panel.hidden = !active;
        if (active) panel.querySelector('[data-stove-product-row]').scrollLeft = 0;
      });
      emit('product-tab', { tab: name });
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activateTab(tab.dataset.stoveProductTab));
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const nextIndex = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
        activateTab(tabs[nextIndex].dataset.stoveProductTab, true);
      });
    });
    showcase.querySelector('[data-stove-showcase-next]')?.addEventListener('click', () => {
      showcase.querySelector('[data-stove-product-panel]:not([hidden]) [data-stove-product-row]')?.scrollBy({ left: showcase.clientWidth * .82, behavior: 'smooth' });
    });
    activateTab('recommended');
  }
  sort.value = defaultSort;
  sortCards();
  apply();
})();
